import { render } from "./GiftsStore.vue?vue&type=template&id=762794c2"
import script from "./GiftsStore.vue?vue&type=script&lang=js"
export * from "./GiftsStore.vue?vue&type=script&lang=js"

import "./GiftsStore.vue?vue&type=style&index=0&id=762794c2&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__